import { api } from '@/api'

type ImageUploadResponce = {
  imageId: number
  imageUrl: string
  success: boolean
}

const uploadImageService = api.injectEndpoints({
  endpoints: (build) => ({
    UploadDeviceImage: build.mutation<ImageUploadResponce, FormData>({
      query: (body) => ({
        url: '/devices/addDeviceImage',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Description'],
    }),
    DeleteDeviceImage: build.mutation<
      ImageUploadResponce,
      { deviceId: number }
    >({
      query: (body) => ({
        url: '/devices/deleteDeviceImage',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Description'],
    }),
  }),
})

export const { useDeleteDeviceImageMutation, useUploadDeviceImageMutation } =
  uploadImageService
